import React, { useContext, useState } from "react";
import { HotelContext } from "../context/hotel";
import { UserContext } from "../context/user";
import { i18nValue } from "../functions";
import Screen from "../components/Screen";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Faqs = (props) => {
  const [openFaq, setOpenFaq] = useState(null);

  const {
    sectionsByCode,
    faqs
  } = useContext(HotelContext);
  const { language } = useContext(UserContext);

  const handleToggle = (index) => {
    if (index === openFaq) {
      return setOpenFaq(null);
    }
    setOpenFaq(index);
  };

  return (
    <Screen
      section={"faqs"}
      title={i18nValue(sectionsByCode["faqs"], "title", language)}
      description={i18nValue(sectionsByCode["faqs"], "desc", language)}
    >
      <div className="mt-2">
        {faqs &&
          faqs.map((faq, index) => {
            const current = openFaq === index;
            return (
              <div
                style={{
                  borderBottom: "1px solid #cacaca",
                  padding: "8px",
                  marginBlock: "5px",
                  whiteSpace: "pre-line",
                }}
                key={index}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "space-between",
                  }}
                >
                  <h4 className="mb-0 font-weight-bold" style={{ fontSize: '1rem' }}>{i18nValue(faq, 'question', language)}</h4>
                  <p className="mb-0" onClick={() => handleToggle(index)} style={{ margin: "-7px -7px -7px 15px", padding: '7px 10px', cursor: 'pointer' }}>
                    {current ? (
                      <FontAwesomeIcon icon={faMinus} />
                    ) : (
                      <FontAwesomeIcon icon={faPlus} />
                    )}
                  </p>
                </div>
                <div
                  style={{
                    maxHeight: current ? "900px" : 0,
                    overflow: "hidden",
                    transition: "all 200ms linear",
                  }}
                >
                  <div
                    className="mt-2 faq-answer"
                    style={{ fontSize: '1rem' }}
                    dangerouslySetInnerHTML={{ __html: i18nValue(faq, 'answer', language) || '' }}
                  />
                </div>
              </div>
            );
          })}
      </div>
    </Screen>
  );
};

export default Faqs;
